// extracted by mini-css-extract-plugin
export default {"wrapper":"activity_vacancies-module___wrapper___aeed170b","header":"activity_vacancies-module___header___a31cd1d4","closeButton":"activity_vacancies-module___closeButton___c6a616fa"};